import { Link, LinkProps } from "@tanstack/react-router";

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";

const helpLinks = [
  {
    name: "Feature Requests",
    href: "https://grazesocial.canny.io/feature-requests",
  },
  {
    name: "Marketplace",
    to: "/marketplace",
  },
];

export function SidebarHelp({
  children,
  collapsible,
}: {
  children?: React.ReactNode;
  collapsible?: string;
}) {
  return (
    <SidebarGroup collapsible={collapsible}>
      {collapsible && <SidebarGroupLabel>Help</SidebarGroupLabel>}
      <SidebarGroupContent>
        <SidebarMenu>
          {children}
          {helpLinks.map((link) => (
            <SidebarMenuItem key={link.name}>
              <SidebarMenuButton asChild>
                {link.to ? (
                  <Link to={link.to as LinkProps["to"]}>{link.name}</Link>
                ) : (
                  <a href={link.href} target="_blank" rel="noreferrer">
                    {link.name}
                  </a>
                )}
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
